(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-table"] && !Shopify.designMode) return;
  try {
    (() => {
    const setQty = (row) => {
      const qty = parseInt(row.dataset.qty, 10);
      if (!qty) return;
      const scope = row.closest('.shopify-section') || document;
      const input = scope.querySelector('.quantity-input');
      if (!input) return;
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    // Actieve staffelrij markeren: hoogste tier waar het huidige aantal in
    // valt; onder de laagste staffel geen markering (zoals de oude site).
    const syncTiers = () => {
      document.querySelectorAll('.product-table__table--tiers').forEach((table) => {
        const scope = table.closest('.shopify-section') || document;
        const input = scope.querySelector('.quantity-input');
        if (!input) return;
        const qty = parseInt(input.value, 10) || 0;
        let active = null;
        const rows = table.querySelectorAll('.product-table__tier');
        rows.forEach((row) => {
          const rowQty = parseInt(row.dataset.qty, 10);
          if (!rowQty || qty < rowQty) return;
          if (!active || rowQty > parseInt(active.dataset.qty, 10)) active = row;
        });
        rows.forEach((row) => {
          row.classList.toggle('product-table__tier--active', row === active);
        });
      });
    };
    document.addEventListener('click', (e) => {
      const row = e.target.closest('.product-table__tier');
      if (row) setQty(row);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const row = e.target.closest('.product-table__tier');
      if (!row) return;
      e.preventDefault();
      setQty(row);
    });
    // Highlight live laten meebewegen met het aantal: typen (input), de
    // change die een tabel-klik dispatcht, en het theme-event van de
    // +/- knoppen en blur (quantity-selector.js, zie events.js).
    document.addEventListener('input', (e) => {
      if (e.target instanceof Element && e.target.matches('.quantity-input')) syncTiers();
    });
    document.addEventListener('change', (e) => {
      if (e.target instanceof Element && e.target.matches('.quantity-input')) syncTiers();
    });
    document.addEventListener('quantity-selector:update', () => syncTiers());
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncTiers());
    } else {
      syncTiers();
    }
    // Prijzen live herrekenen bij variantwissel (theme event, zie events.js)
    document.addEventListener('variant:update', (e) => {
      const detail = e.detail || {};
      const price = detail.resource && detail.resource.price;
      const productId = detail.data && detail.data.productId;
      const sameProduct = (table) =>
        !productId || !table.dataset.productId || table.dataset.productId === String(productId);
      // "Wissen" (terug naar "Wähle eine Option"): geen variant, wel de verse
      // HTML van de kale product-URL. Daarin staat de tabel al op de laagste
      // variantprijs (zelfde bron als het prijsblok) — cellen overnemen.
      if (!price) {
        const html = detail.data && detail.data.cleared && detail.data.html;
        if (!html) return;
        document.querySelectorAll('.product-table__table--tiers').forEach((table) => {
          if (!sameProduct(table)) return;
          const fresh = Array.from(html.querySelectorAll('.product-table__table--tiers')).find(
            (t) => t.dataset.productId === table.dataset.productId
          );
          if (!fresh) return;
          const freshCells = fresh.querySelectorAll('[data-pct]');
          table.querySelectorAll('[data-pct]').forEach((cell, i) => {
            if (freshCells[i]) cell.textContent = freshCells[i].textContent;
          });
        });
        return;
      }
      document.querySelectorAll('.product-table__table--tiers').forEach((table) => {
        if (!sameProduct(table)) return;
        const fmt = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: table.dataset.currency || 'EUR',
        });
        table.querySelectorAll('[data-pct]').forEach((cell) => {
          const pct = parseFloat(cell.dataset.pct);
          if (Number.isNaN(pct)) return;
          cell.textContent = fmt.format(((100 - pct) * price) / 100 / 100);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
